var NODE_ENV = "production";
var SITE = "tsw";
var IS_NEXT = "true" === 'true';
var API_URL = '';
var INSTAGRAM_USER = '';
var PROD_ROOT_DOMAIN = '';
var MERCHANT_NAME = '';
var INSTAGRAM_TOKENS = {
  'tyw': 'IGQWROT1hVd1l6TkNvb1JlRU5JTENPclFSNUJydlh1UFRtU3piNUpiaml2SUFzVEVsbS1SVDNLRU5KbzRiZADlhX09GN1YteGxkVjdNLTVEYnhlbEVuWk1PYnBlNG5jMWJCLXp3MEhXMnJWWm9FdTFvVTQzbGQxR3cZD',
  'tsw': 'IGQWROZAzRfbTMwZAkI4S0NmMjkzNDFIVVBRVGZACLURmMXpSMF9ISTlvQktnUnZAuSmd1X0hreFBFZA2YwR0RwYUd0U0w3UXdjM2dmbEhBaUhSY2dWRlJRRGw2cFl2SnJPV2lDajBRYTdjeDFma2JTWU9UNGRXd2VOZAmsZD',
  'qd': 'IGQWRQNEk2cEJ6amRyZA1RFX2JMbmlpdzFvOEFBYkpUMm43QjJMRW05OFhrRzJ2em9HQnEySnJ5X1ZAZAMnFOSkJGNUJHZAGJLOUxfNHJIcTB3RFpVT29Hd0JwRktYT1lHMTM0Ykw5dnJpbDBXM2EtQXpiODdtcXl3c0UZD',
  'ynf': 'IGQWROV1p0NTBMWDg4VTRUbGNmblBiMXN0alkzWmVxRmZA3THotT19qb05BWWdUOFNoUndaWFp2aHRyVGRMbUJvZAVFHM0pVNFhSM3dPXzBZARGpFb0tUMnpsRHM2NXV6TWg3emlhSFdER0xxLWQtTXF3Qk1NZAUlhbmMZD',
  'ohso': 'IGQWRORmF4TUZAaUWpIS1RZAQi1ETGUySDFRVm40NFJKYW5uVWp4X0p4UWZAEa2taVHQwS056b0l5b25tS1RKdno5aUptTlBqQjdkQS1sejNuM3NWMnZAueGxjMGh4elQ1QXdjOGRuemJ0MWZALcnc5aU4weVFLZAkp1VUkZD'
};
if (SITE === 'tyw') {
  INSTAGRAM_USER = 'theyachtweek';
  PROD_ROOT_DOMAIN = 'theyachtweek.com';
  MERCHANT_NAME = 'The Yacht Week';
  if (NODE_ENV === 'development') {
    API_URL = 'https://www.theyachtweek.com';
  } else if (NODE_ENV === 'staging') {
    API_URL = 'https://test.theyachtweek.com';
  } else if (NODE_ENV === 'production') {
    API_URL = 'https://www.theyachtweek.com';
  }
} else if (SITE === 'tsw') {
  INSTAGRAM_USER = 'theskiweek';
  PROD_ROOT_DOMAIN = 'theskiweek.com';
  MERCHANT_NAME = 'The Ski Week';
  if (NODE_ENV === 'development') {
    API_URL = 'http://tsw.lh';
  } else if (NODE_ENV === 'staging') {
    API_URL = 'https://test.theskiweek.com';
  } else if (NODE_ENV === 'production') {
    API_URL = 'https://www.theskiweek.com';
  }
} else if (SITE === 'qd') {
  INSTAGRAM_USER = 'quarterdeck.co';
  PROD_ROOT_DOMAIN = 'quarterdeck.co';
  if (NODE_ENV === 'development') {
    API_URL = 'http://qd.lh';
  } else if (NODE_ENV === 'staging') {
    API_URL = 'https://test.quarterdeck.co';
  } else if (NODE_ENV === 'production') {
    API_URL = 'https://www.quarterdeck.co';
  }
} else if (SITE === 'ynf') {
  INSTAGRAM_USER = 'yachtsandfriends';
  PROD_ROOT_DOMAIN = 'yachtsandfriends';
  // Setting all API urls to live for now, can change back later
  if (NODE_ENV === 'development') {
    API_URL = 'https://www.yachtsandfriends.com';
  } else if (NODE_ENV === 'staging') {
    API_URL = 'https://www.yachtsandfriends.com';
  } else if (NODE_ENV === 'production') {
    API_URL = 'https://www.yachtsandfriends.com';
  }
} else if (SITE === 'day8') {
  INSTAGRAM_USER = 'day8';
  PROD_ROOT_DOMAIN = 'day8';
  // Setting all API urls to live for now, can change back later
  if (NODE_ENV === 'development') {
    API_URL = 'http://localhost:3000';
  } else if (NODE_ENV === 'staging') {
    API_URL = 'https://www.day8.com';
  } else if (NODE_ENV === 'production') {
    API_URL = 'https://www.day8.com';
  }
}
var ENV = {
  API_URL: API_URL,
  SITE: SITE,
  NODE_ENV: NODE_ENV,
  INSTAGRAM_USER: INSTAGRAM_USER,
  INSTAGRAM_TOKENS: INSTAGRAM_TOKENS,
  IS_NEXT: IS_NEXT,
  PROD_ROOT_DOMAIN: PROD_ROOT_DOMAIN,
  MERCHANT_NAME: MERCHANT_NAME
};
module.exports.ENV = ENV;